var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2606 4.88372H19.231V2.61628C19.231 1.17365 18.0365 0 16.5683 0H3.43224C1.96401 0 0.769531 1.17365 0.769531 2.61628V12.3837C0.769531 13.8264 1.96401 15 3.43224 15H16.5683C18.0365 15 19.231 13.8264 19.231 12.3837V10.1163H14.2606C12.7924 10.1163 11.5979 8.94263 11.5979 7.5C11.5979 6.05737 12.7924 4.88372 14.2606 4.88372Z",
    fill: "url(#paint0_linear_9_411)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2607 5.93018C13.3798 5.93018 12.6631 6.63436 12.6631 7.49996C12.6631 8.36555 13.3798 9.06974 14.2607 9.06974H19.2311V5.93021H14.2607V5.93018ZM14.9708 8.02321H14.2607C13.9666 8.02321 13.7282 7.78891 13.7282 7.49996C13.7282 7.211 13.9666 6.97671 14.2607 6.97671H14.9708C15.2649 6.97671 15.5033 7.211 15.5033 7.49996C15.5033 7.78891 15.2649 8.02321 14.9708 8.02321Z",
    fill: "url(#paint1_linear_9_411)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_411",
    x1: 0.769531,
    y1: 3.47973,
    x2: 19.1968,
    y2: 4.18594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA384D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9_411",
    x1: 12.6631,
    y1: 6.6585,
    x2: 19.2008,
    y2: 7.08439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA384D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletRed);
export default __webpack_public_path__ + "static/media/wallet-red.d2a78061202ea5e7818694d4960dde30.svg";
export { ForwardRef as ReactComponent };